<template>
  <div>
    <main-nav></main-nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 mt-5 fixed">
          <record-detail></record-detail>
        </div>
        <div class="col-sm-3 mt-5 scroll">
          <record-list></record-list>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.scroll {
  overflow-y: scroll;
  height: 100vh;
}
.fixed {
  height: 100vh;
}
.tiny {
  font-size: 0.8em;
}
</style>

<script>
import MainNav from "./MainNav";
import RecordDetail from "./RecordDetail";
import RecordList from "./RecordList";

export default {
  name: "Home",
  components: {
    RecordDetail,
    MainNav,
    RecordList
  },
  mounted: function() {
    this.$store.dispatch("loadAgreements");
    this.$store.dispatch("loadCorrespondences");
    this.$store.dispatch("loadAgencies");
    this.$store.dispatch("loadRecordStates");
  }
};
</script>
